module.exports = __webpack_public_path__ + "static/media/dolly-flatbed-alt.ce953cb8.svg";